/*
 * @Author: wzh
 * @LastEditTime: 2025-06-10 11:02:30
 * @Description:
 */

import LoginPageHB from "./login-hb.vue";
import LoginPage from "./login.vue";
import Logout from "./logout.vue";
import ThirdLogin from "./thirdLogin.vue";

function getPageLoginRoute() {
  if (process.env.VUE_APP_ISHB == 1) {
    return LoginPageHB;
  } else {
    return LoginPage;
  }
}

export { getPageLoginRoute, LoginPage, Logout, ThirdLogin };
